<div class="plant-status-wrapper">
  <div
    class="plant-status-container"
    style="
      background: url(./assets/img/dashboard/plant-status-bg.jpg);
      background-size: cover;
      background-repeat: no-repeat;
      background-position: content-box;
    "
  >
    <div class="plant-status-container-bg-color">
      <mat-accordion>
        <mat-expansion-panel
          [expanded]="true"
          hideToggle="true"
          (click)="click()"
          class="plant-status-container-content"
        >
          <mat-expansion-panel-header>
            <mat-panel-title>
              <ng-container *ngIf="icon">
                <i
                  class="fa fa-sort-desc arrow-expansion-panel-customize desc"
                  aria-hidden="true"
                ></i>
              </ng-container>
              <ng-container *ngIf="!icon">
                <i
                  class="fa fa-sort-asc arrow-expansion-panel-customize asc"
                  aria-hidden="true"
                ></i>
              </ng-container>
              <span class="title-header">Realtime Plant Status</span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div fxLayout="row wrap" fxLayout.xs="column" class="items-row">
            <div
              class="items-container"
              fxFlex="33.3%;"
              fxFlex.xs="100%"
              fxLayout="row wrap"
              fxLayout.xs="row"
              fxLayoutAlign="center stretch"
            >
              <div fxFlex="40%;" fxFlex.xs="40%">
                <img
                  class="widget-images"
                  src="./assets/img/dashboard/irradiance.png"
                  alt="irradiance image"
                />
              </div>
              <div
                class="info-container"
                fxFlex="60%;"
                fxFlex.xs="60%"
                fxLayout="column wrap"
                fxLayout.xs="column"
                fxLayoutAlign="center left"
              >
                <div class="value-info">
                  {{ latestIrradiance | number: '1.0-2' }} W/m2
                </div>
                <div class="title-info">Irradiance</div>
              </div>
            </div>
            <div
              class="items-container"
              fxFlex="33.3%;"
              fxFlex.xs="100%"
              fxLayout="row wrap"
              fxLayout.xs="row"
              fxLayoutAlign="center stretch"
            >
              <div fxFlex="40%;" fxFlex.xs="40%">
                <img
                  class="widget-images"
                  src="./assets/img/dashboard/dc-power.png"
                  alt="dc-power image"
                />
              </div>
              <div
                class="info-container"
                fxFlex="60%;"
                fxFlex.xs="60%"
                fxLayout="column wrap"
                fxLayout.xs="column"
                fxLayoutAlign="center left"
              >
                <div class="value-info">
                  {{ totalDCPower | number: '1.0-2' }} MW
                </div>
                <div class="title-info">DC Power</div>
              </div>
            </div>
            <div
              class="items-container"
              fxFlex="33.3%;"
              fxFlex.xs="100%"
              fxLayout="row wrap"
              fxLayout.xs="row"
              fxLayoutAlign="center stretch"
            >
              <div fxFlex="40%;" fxFlex.xs="40%">
                <img
                  class="widget-images"
                  src="./assets/img/dashboard/ac-power.png"
                  alt="ac-power image"
                />
              </div>
              <div
                class="info-container"
                fxFlex="60%;"
                fxFlex.xs="60%"
                fxLayout="column wrap"
                fxLayout.xs="column"
                fxLayoutAlign="center left"
              >
                <div class="value-info">
                  {{ totalACPower | number: '1.0-2' }} MW
                </div>
                <div class="title-info">AC Power</div>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
</div>
<app-plant-key></app-plant-key>
